import React from 'react';

import { GridContainer, CellContainer, EmptyGridContainer } from './styles';
import type { GridProps } from './types';

const Grid: React.FC<GridProps> = ({
  items,
  minElementWidth = '100px',
  emptyGridMessage = 'No items found',
  gap = '24px',
  maxColumnsCount,
}) => {
  if (!items?.length) {
    return <EmptyGridContainer>{emptyGridMessage}</EmptyGridContainer>;
  }

  return (
    <GridContainer gap={gap} maxColumnsCount={maxColumnsCount}>
      {items.map(({ id, element }) => (
        <CellContainer key={id} minElementWidth={minElementWidth}>
          {element}
        </CellContainer>
      ))}
    </GridContainer>
  );
};

export default Grid;
